export default __webpack_public_path__ + "static/media/python-logo.42d5a2c0.svg";